export const env = {
  BASE_URL: import.meta.env.VITE_APP_API_SERVER as string,
  SENTRY_DSN: import.meta.env.VITE_APP_SENTRY_DSN as string,
  SENTRY_ENV: (import.meta.env.VITE_APP_SENTRY_ENV ?? 'local') as SentryEnv,
  SENTRY_DEBUG: JSON.parse(
    import.meta.env.VITE_APP_SENTRY_DEBUG ?? 'false',
  ) as boolean,
  SENTRY_WITH_REDUX: JSON.parse(
    import.meta.env.VITE_APP_SENTRY_WITH_REDUX ?? 'false',
  ) as boolean,
};

type SentryEnv = 'local' | 'dev' | 'stage' | 'prod';
